/*
 * @Author: songjingyang songjingyang@meishubao.com
 * @Date: 2025-03-28 15:40:04
 * @LastEditors: songjingyang songjingyang@meishubao.com
 * @LastEditTime: 2025-03-28 15:40:39
 * @FilePath: src/utils/theme.ts
 * @Description: TypeScript版本 - 自动转换
 */

// 处理主题样式
export function handleThemeStyle(theme: any): any {
	document.documentElement.style.setProperty('--el-color-primary', theme)
	const rgb = hexToRgb(theme)
	document.documentElement.style.setProperty('--el-color-primary-rgb', rgb.join(', '))
	document.documentElement.style.setProperty('--domi-primary', theme)
	document.documentElement.style.setProperty('--domi-primary-hover', getLightColor(theme, 0.3))
	document.documentElement.style.setProperty('--domi-primary-active', getDarkColor(theme, 0.2))
	document.documentElement.style.setProperty('--domi-primary-subtle', getLightColor(theme, 0.9))
	document.documentElement.style.setProperty('--domi-primary-selected', getLightColor(theme, 0.8))
	document.documentElement.style.setProperty('--domi-primary-border', theme)
	document.documentElement.style.setProperty('--domi-on-primary', '#fff')
	document.documentElement.style.setProperty('--domi-primary-text', theme)
	document.documentElement.style.setProperty('--domi-primary-text-hover', getDarkColor(theme, 0.2))
	document.documentElement.style.setProperty('--menu-active-text', theme)
	for (let i = 1; i <= 9; i++) {
		document.documentElement.style.setProperty(`--el-color-primary-light-${i}`, `${getLightColor(theme, i / 10)}`)
	}
	for (let i = 1; i <= 9; i++) {
		document.documentElement.style.setProperty(`--el-color-primary-dark-${i}`, `${getDarkColor(theme, i / 10)}`)
	}

	// Boss 金黄使用设计系统中定义的交互态，避免自动混色与 Boss 端不一致。
	if (theme.toUpperCase() === '#F5B71C') {
		document.documentElement.style.setProperty('--el-color-primary-light-3', '#F8C84E')
		document.documentElement.style.setProperty('--el-color-primary-light-5', '#F0D78A')
		document.documentElement.style.setProperty('--el-color-primary-light-7', '#FFF3C2')
		document.documentElement.style.setProperty('--el-color-primary-light-8', '#FFF5CE')
		document.documentElement.style.setProperty('--el-color-primary-light-9', '#FFF7DB')
		document.documentElement.style.setProperty('--el-color-primary-dark-2', '#D99A00')
		document.documentElement.style.setProperty('--domi-primary-hover', '#F8C84E')
		document.documentElement.style.setProperty('--domi-primary-active', '#D99A00')
		document.documentElement.style.setProperty('--domi-primary-subtle', '#FFF7DB')
		document.documentElement.style.setProperty('--domi-primary-selected', '#FFF3C2')
		document.documentElement.style.setProperty('--domi-primary-border', '#E5A600')
		document.documentElement.style.setProperty('--domi-on-primary', '#1D2129')
		document.documentElement.style.setProperty('--domi-primary-text', '#7A5200')
		document.documentElement.style.setProperty('--domi-primary-text-hover', '#5F4000')
		document.documentElement.style.setProperty('--menu-active-text', '#7A5200')
	}
}

// hex颜色转rgb颜色
export function hexToRgb(str: any): any {
	str = str.replace('#', '')
	let hexs = str.match(/../g)
	for (let i = 0; i < 3; i++) {
		hexs[i] = parseInt(hexs[i], 16)
	}
	return hexs
}

// rgb颜色转Hex颜色
export function rgbToHex(r: any, g: any, b: any): any {
	let hexs = [r.toString(16), g.toString(16), b.toString(16)]
	for (let i = 0; i < 3; i++) {
		if (hexs[i].length == 1) {
			hexs[i] = `0${hexs[i]}`
		}
	}
	return `#${hexs.join('')}`
}

// 变浅颜色值
export function getLightColor(color: any, level: any): any {
	let rgb = hexToRgb(color)
	for (let i = 0; i < 3; i++) {
		rgb[i] = Math.floor((255 - rgb[i]) * level + rgb[i])
	}
	return rgbToHex(rgb[0], rgb[1], rgb[2])
}

// 变深颜色值
export function getDarkColor(color: any, level: any): any {
	let rgb = hexToRgb(color)
	for (let i = 0; i < 3; i++) {
		rgb[i] = Math.floor(rgb[i] * (1 - level))
	}
	return rgbToHex(rgb[0], rgb[1], rgb[2])
}
